import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DOMPurify from "dompurify";
import PaymentComponent from "../components/PaymentComponent";
import {Spinner} from 'react-bootstrap';
import ReceiptItem from "../components/ReceiptItem";
import { useRef } from "react";
import html2canvas from "html2canvas"
import jsPDF from "jspdf"

function Payment(){

    const api_url = "/api";

    const location = useLocation();
    const pdfRef = useRef();
    const { cartItems, discount, totalPrice, subtotal } = location.state;
    const [paymentState, setPaymentState] = useState({state:'not initiated'})

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone:""
    });

    async function LogPage(){
       try{

        const response = await fetch(`${api_url}/views`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            name: "payment",
            view: "PaymemtPage"
        }),
        });

      const data = await response.json();
      if(!response.ok){
        throw new Error(data.message || "Upload failed");
      }
      console.log(data)
     
       }catch(error){
         console.error("Failed to log view:", error);
       }
    }

    useEffect(()=>{
             LogPage()
           },[])

    useEffect(() => {
    if (window.fbq) {
        window.fbq('track', 'Purchase', {
            value: totalPrice,
            currency: 'ZMW',
            content_ids: cartItems.map(item => item.id),
            content_type: 'product',
            num_items: cartItems.reduce((sum, item) => sum + item.quantity, 0)
        });
    }
}, []);

    const sanitizeInput = (input) => {
        return DOMPurify.sanitize(input);
    };

    const downloadPDF = async () => {
        const element = pdfRef.current;
        const canvas = await html2canvas(element, {
            scale: 2
        })

        const imgData = canvas.toDataURL("image/png")
        const pdf = new jsPDF("p", "mm", "a4")
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight)
        pdf.save("document.pdf")
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: sanitizeInput(value),
        });
    };
    return(
          paymentState.state == 'not initiated' ?
          (
            <div className="flex one column">
                <div className="width-100 gold-bg flex one center">
                    <p className='big-txt special-font bold'>Payment</p>
                </div>
                <div className="flex four column">
                    <div className="flex one center">
                        <input 
                            className="input-payment"
                            name="phone"
                            placeholder="Phone number format 0977xxxxxx"
                            value={formData.phone}
                            onChange={handleInputChange}
                            required
                            />
                        </div>
                    <div className="flex one center">
                        <div className="flex one center"></div>
                        <div className="flex three center">
                                <p>To make payment please input your phone number and click the make payment button</p>
                        </div>
                        <div className="flex one center"></div>
                    </div>
                
                </div>
                <div className="flex three center">
                    <PaymentComponent formData={formData} totalPrice={totalPrice} discount={discount} subtotal={subtotal} cartItems={cartItems} setPaymentState={setPaymentState}/>
                </div>
                <div className="flex three"></div>
            </div>
          )
          : 
          (
            paymentState.state == 'pending'?
            (
               <div className="flex one center">
                <Spinner/>
               </div>
            )
            :
            (
                paymentState.state == 'success' ?
                (
                     <div className="flex one column overflow" ref={pdfRef}>
                        <div className="flex one column">
                            <div className="cart-item flex center">
                                <p className="bold">E-Receipt</p>
                            </div>
                            {paymentState.items?.cartItems?.map(item =>(
                                <ReceiptItem image={item.image} name={item.productName} price={item.price} size={item.size} quantity={item.quantity}/>
                            ))}
                            <div className="flex one column">
                                 <div className="cart-item flex column">
                                    <div className="flex one">
                                        <div className="flex one center">
                                            <span className="bold">Total :</span>
                                        </div>
                                        <div className="flex one center">
                                            <span>{paymentState.items.total}</span>
                                        </div>
                                    </div>
                                    <div className="flex one">
                                        <div className="flex one center">
                                            <span className="bold">Discount :</span>
                                        </div>
                                        <div className="flex one center">
                                            <span>{paymentState.items.discount}</span>
                                        </div>
                                    </div>
                                    <div className="flex one">
                                        <div className="flex one center">
                                            <span className="bold">Subtotal :</span>
                                        </div>
                                        <div className="flex one center">
                                            <span>{paymentState.items.subtotal}</span>
                                        </div>
                                    </div>
                                 </div>
                            </div>
                            <div className="cart-item flex center">
                                <div className='checkout-btn flex center' onClick={()=>{downloadPDF()}}>
                                    <span className='white-txt'>Download Receipt</span>
                                </div>
                            </div>
                        </div>
                     </div>
                )
                :
                (
                    <div className="flex one center">
                       <>{paymentState.message}</>
                   </div>
                )
            )
           
          )
        
    )
}

export default Payment;